/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Privacy_PagesInputs */

const fr_legal_privacy_pages = /** @type {(inputs: Legal_Privacy_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages visitées`)
};

const en_legal_privacy_pages = /** @type {(inputs: Legal_Privacy_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visited pages`)
};

/**
* | output |
* | --- |
* | "Visited pages" |
*
* @param {Legal_Privacy_PagesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_privacy_pages = /** @type {((inputs?: Legal_Privacy_PagesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Privacy_PagesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_privacy_pages(inputs)
	return en_legal_privacy_pages(inputs)
});